export const SEARCH_QUERY = 'searchKey';
